(() => {
  if (customElements.get('almond-resource')) return;
  customElements.define('almond-resource', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (this.ready) return;
      const form = this.querySelector('form');
      if (!form) return;
      this.ready = true;
      const button = form.querySelector('button');
      const status = this.querySelector('[role=status]');
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-resource-open]');
      opener.addEventListener('click', () => {
        dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        this.scrollLocked = true;
        document.documentElement.style.overflow = 'hidden';
        (form.hidden ? status : form.elements.email).focus();
      });
      this.querySelector('[data-resource-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.scrollLocked = false;
        opener.focus();
      });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      let file;
      try {
        file = new URL(this.dataset.file);
        if (file.protocol !== 'https:' || !file.pathname.toLowerCase().endsWith('.pdf')) throw new Error();
      } catch { status.textContent = 'This download is not available yet.'; return; }
      if (!this.dataset.site || !this.dataset.list) {
        status.textContent = 'Download signup is not available yet. Please check back soon.';
        return;
      }
      button.disabled = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        if (window.Shopify?.designMode) {
          status.textContent = 'Theme editor preview: no signup was sent. Test submissions use mocked responses locally.';
          return;
        }
        this.busy = true;
        // Reserve during the click gesture; navigate only after acceptance and PDF validation.
        const pdfTab = window.open('about:blank', '_blank');
        if (pdfTab) pdfTab.opener = null;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = 'Requesting your download…';
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        try {
          if (!this.accepted) {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.site)}`, {
            method: 'POST', credentials: 'omit', signal: controller.signal,
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Almond Free Resources',
                profile: { data: { type: 'profile', attributes: {
                  email: form.elements.email.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  properties: { almond_free_resource_requested: this.dataset.resource }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
            } })
          });
          if (response.status !== 202) throw new Error();
          this.accepted = true;
          form.elements.email.disabled = true;
          }
          status.textContent = 'Preparing your PDF…';
          const pdf = await fetch(file.href, { credentials: 'omit', signal: controller.signal });
          if (!pdf.ok) throw new Error();
          const blob = await pdf.blob();
          if (!(await blob.slice(0, 5).text()).startsWith('%PDF-')) throw new Error();
          const objectURL = URL.createObjectURL(blob);
          const download = document.createElement('a');
          download.href = objectURL;
          download.download = file.pathname.split('/').pop();
          download.hidden = true;
          this.append(download);
          download.click();
          download.remove();
          const canOpenTab = pdfTab && !pdfTab.closed;
          if (canOpenTab) pdfTab.location.replace(file.href);
          setTimeout(() => URL.revokeObjectURL(objectURL), 60000);
          form.hidden = true;
          form.reset();
          this.querySelector('.almond-resource__intro').hidden = true;
          status.textContent = canOpenTab ? 'Your PDF download has started and the PDF is open in a new tab. Enjoy!' : 'Your PDF download has started. Your browser prevented the new tab from opening.';
          status.focus();
        } catch {
          if (pdfTab && !pdfTab.closed) pdfTab.close();
          status.textContent = this.accepted ? 'Your signup was accepted, but the PDF could not be downloaded. Please retry the download below.' : 'We couldn’t accept your request. Please try again. Your download remains locked.';
          if (this.accepted) button.textContent = 'Retry download';
          status.focus();
        } finally {
          clearTimeout(timer);
          this.busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    }
    disconnectedCallback() {
      if (this.scrollLocked) {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.scrollLocked = false;
      }
    }
  });
})();
